import { assignInlineVars } from "@vanilla-extract/dynamic";
import { cx } from "class-variance-authority";

import { rawPalette } from "../../styles/theme.css";
import { Tag } from "../Tag";

import * as theme from "./ActivityTimelineItem.css";

export interface ActivityTimelineItemProps {
    /** Bold first line in the left gutter, e.g. a date. */
    date?: React.ReactNode;
    /** Muted second line in the left gutter, e.g. a time + timezone. */
    time?: React.ReactNode;
    /** The coloured status chip label, e.g. "Created". */
    title?: React.ReactNode;
    /** Muted line under the chip, e.g. "by System". */
    subtitle?: React.ReactNode;
    /** Any CSS color for the chip + dot. Omit for a neutral grey. */
    color?: string;
    /** Arbitrary content rendered below the heading (notes, cards, anything). */
    children?: React.ReactNode;
    className?: string;
}

export function ActivityTimelineItem({
    date,
    time,
    title,
    subtitle,
    color,
    children,
    className,
}: ActivityTimelineItemProps) {
    const fill = color ?? rawPalette.base.greys[600];

    return (
        <div
            className={cx(theme.root, className)}
            style={assignInlineVars({
                [theme.colorVar]: fill,
            })}
        >
            <div className={theme.gutter}>
                {date && <span className={theme.date}>{date}</span>}
                {time && <span className={theme.time}>{time}</span>}
            </div>

            <div className={theme.rail}>
                <span className={theme.line} aria-hidden />
                <span className={theme.dot} aria-hidden />
            </div>

            <div className={theme.content}>
                <div className={theme.heading}>
                    {title && <Tag className={theme.chip}>{title}</Tag>}
                    {subtitle && (
                        <span className={theme.subtitle}>{subtitle}</span>
                    )}
                </div>
                {children}
            </div>
        </div>
    );
}
